export type OnboardingIntent = 'REVIEWER' | 'WISHLIST_BUILDER' | 'TRACKER';

export type OnboardingStep = 1 | 2 | 3 | 4 | 5 | 6;

export interface OnboardingPayload {
  intent?: OnboardingIntent;
  taste_preferences?: {
    cuisines: string[];
    dietary_restrictions: string[];
  };
  friend_seeding_skipped?: boolean;
}

export type OnboardingStatus = 'loading' | 'required' | 'not_required' | 'error';

export interface UseOnboardingReturn {
  status: OnboardingStatus;
  currentStep: OnboardingStep;
  payload: OnboardingPayload;
  isAdvancing: boolean;
  start: () => Promise<void>;
  nextStep: () => Promise<void>;
  goBack: () => void;
  setIntent: (intent: OnboardingIntent) => void;
  setTastePreferences: (cuisines: string[], dietaryRestrictions: string[]) => Promise<void>;
  skipFriendSeeding: () => void;
  complete: () => Promise<void>;
}
